// extracted by mini-css-extract-plugin
export var subtitle = "_d4-2";
export var title = "_d4-0";
export var titleNoWrap = "_d4-1";